import React, { useState } from 'react';
import emailjs from "emailjs-com";

const Contact = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [emailSent, setEmailSent] = useState(false);

const submit = () => {
  if (name && email && message) {
     const serviceId = "service_8vo5319";
     const templateId = "template_20fmn5y";
     const userId = "GboNiTu6-o-qRur_5";
     const templateParams = {
       name,
       email,
       message,
     };

     emailjs.send(serviceId, templateId, templateParams, userId)
       .then((response) => console.log(response))
       .then((error) => console.log(error));

    setName("");
    setEmail("");
    setMessage("");
    setEmailSent(true);
  } else {
    alert("Please fill in all fields.");
  }
};

    return (
      <div className="my-10 py-10">
        <h1 className="text-5xl my-12">Let's get in touch</h1>
        {/* <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        /> */}
        <div className="flex flex-col justify-center items-center">
          <div className="form-control">
            <label className="input-group input-group-md">
              <span>Name</span>
              <input
                onChange={(e) => setName(e.target.value)}
                type="text"
                value={name}
                placeholder="Your Name"
                className="input input-bordered input-md"
              />
            </label>
          </div>
          <div className="form-control my-4 ">
            <label className="input-group">
              <span>Email</span>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                value={email}
                placeholder="info@site.com"
                className="input input-bordered"
              />
            </label>
            <>
              <h1>
                <span className='text-gray-400'>Or Manually Mail Me at</span> <br />{" "}
                <span>solih.ahmad.sohan@gmail.com</span>
              </h1>
            </>
          </div>
          {/* <input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        /> */}
          {/* <textarea
          placeholder="Your message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea> */}
          <div className="form-control my-4 w-64 ">
            <textarea
              className="textarea textarea-warning "
              placeholder="Your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button className="btn " onClick={submit}>
            Send Message
          </button>
        </div>
        {emailSent && (
          <span className="">
            Thank you for your message, we will be in touch in no time!
          </span>
        )}
      </div>
    );
};

export default Contact;